import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api'
import { Map, DataLayer, Feature } from 'google-react-maps';
import { ListDownloadButton } from 'components';
const Stars = (num) => {
  let stars = [];
  for (var i = 0; i < num; i++) {
    stars.push(<i className='fa fa-star'></i>)
  };
  for (var i = 0; i < 5 - num; i++) {
    stars.push(<i className='fa fa-star-o'></i>)
  };
  return stars;
}

class FeatureDetails extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'FeatureDetails';
    this.dataLayer = null;
  }
  state = {
    count: undefined
  }
  componentDidMount() {
    const { feature } = this.props;
    if(feature && feature.geometry.type == 'Polygon') {
      this.setState({count: 0, loading_count: true});
      Api.countHouses(
        this.props.feature.geometry.coordinates[0].map(latLng => ({Latitude: latLng[1], Longitude: latLng[0]}))
      )
      .then(response => this.setState({count: response.count}))
      .catch(ex => console.error(ex)).then(e => this.setState({loading_count: false}));
    }

    setTimeout(f => {
      if(this.dataLayer) {
        this.dataLayer.focus()
      }
    }, 100);
  }
  componentDidUpdate(prevProps) {
    if(
      this.props.feature &&
      this.props.feature.geometry.type == 'Polygon' &&
      (this.props.feature && !prevProps.feature) ||
      (this.props.feature && prevProps.feature && this.props.feature._id != prevProps.feature._id)
    ) {
      this.setState({count: 0, loading_count: true});
      Api.countHouses(
        this.props.feature.geometry.coordinates[0].map(latLng => ({Latitude: latLng[1], Longitude: latLng[0]}))
      )
      .then(response => this.setState({count: response.count}))
      .catch(ex => console.error(ex)).then(e => this.setState({loading_count: false}));
    }
    setTimeout(f => {
      if(this.dataLayer) {
        this.dataLayer.focus()
      }
    }, 100);
  }
  render() {
    if(!this.props.feature || !this.props.feature._id) {
      return <span></span>
    }

    const {feature, downloaded_map} = this.props;
    if(!downloaded_map) {
      return <noscript />
    }
    const {map} = downloaded_map;

    return (
      <div className={'panel '+ this.props.className}>
        <div className='panel-body panel-body-nopadding'>
          <Map
            api-key='AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw'
            style={{height:'200px', width : '100%'}}
            >
            <DataLayer ref={(d) => { this.dataLayer = d; }} key={this.props.feature._id} zIndex={1} fillOpacity={0.5} >
              {feature.geometry.type == 'Polygon' ? (
                <Feature id={this.props.feature._id} geoJson={this.props.feature} editable={false} fillOpacity={0.5} />
              ) : (
                <Feature icon={feature.properties.icon} geoJson={feature} id={feature.properties._id} />
              )}
            </DataLayer>
          </Map>
          <div className='p-md'>
            <h4 className='text-weight-semibold mt-none'>Map - {Stars(map.properties.star_level)}</h4>
            <h6 className='text-muted'>{map.properties.title || ''}</h6>
            <hr className='dotted short' />
            <ul className='list-unstyled'>
              {map.properties.storm_date ? <li><i className='fa fa-calendar'></i> {moment(map.properties.storm_date.slice(0,10)).format('MMM DD, YYYY')}</li> : ''}
            </ul>
            <hr className='dotted short' />
            <div className='btn-group pull-right'>
              <div onClick={f => {
                if(!downloaded_map.visible){
                  this.props.showDownloadedMap(downloaded_map.id)
                }
                else {
                  this.props.hideDownloadedMap(downloaded_map.id)
                }
              }} className='btn btn-default'><i className={`fa fa-${downloaded_map.visible ? 'eye' : 'eye-slash'}`}></i></div>
              <div onClick={f => {
                this.props.removeDownloadedMap(downloaded_map.id);
              }} className='btn btn-danger'><i className='fa fa-minus'></i></div>
            </div>
          </div>
          <div className='p-md'>
            {feature.geometry.type == 'Polygon' ? (
              <div>
                <h4 className='text-weight-semibold mt-none'>Swath Details</h4>
                <hr className='dotted short' />
                <ul className='list-unstyled mb-sm'>
                  {feature.properties.houseCount ? <li><i className='fa fa-home'></i> {feature.properties.houseCount} House{feature.properties.houseCount == 1 ? '' : 's'}</li> : ''}
                  {feature.properties.hailSize ? <li><i className='fa fa-certificate'></i> {`${feature.properties.hailSize}' ${feature.properties.hail_isolated || feature.properties.isolated ? 'Isolated' : ''} Hail`}</li> : ''}
                  {feature.properties.hailTime ? <li><i className='fa fa-clock-o'></i> {feature.properties.hailTime}</li> : ''}
                  {feature.properties.windSpeed ? <li><i className='wi wi-windy'></i> {feature.properties.windSpeed}</li> : ''}
                  {this.state.loading_count ? <li><i className='fa fa-spin fa-spinner'></i> Counting Contacts</li>: this.state.count > 0 ? <li><i className='fa fa-list-alt'></i> {this.state.count} Estimated Available Contacts</li> : null}
                </ul>
                <ListDownloadButton mapID={map._id} featureID={feature._id} />
              </div>
            ) : null}
          </div>
        </div>
        {feature && feature.geometry.type == 'Polygon' ? (
          <div className='panel-footer panel-footer-btn-group'>
            <a onClick={e => {
              e.preventDefault();
              if(this.props.onFilter) {
                this.props.onFilter(this.props.feature, downloaded_map.map);
              }
            }} href='#'><i className='fa fa-filter'></i> Filter By Swath</a>
          </div>
        ) : null}
      </div>
    )
  }
}

FeatureDetails.propTypes = {
  feature : PropTypes.object,
  downloaded_map : PropTypes.object,
  onFilter : PropTypes.func,
}

const mapStateToProps = (({map_search}) => ({map_search}));

export default connect(mapStateToProps,Actions)(FeatureDetails);



// WEBPACK FOOTER //
// ./src/browser/components/clients/map/feature-details.js